<!-- Copyright (C) 2022 by Posit Software, PBC. -->

<template>
  <div class="wizard-panel wizard-panel__shiny-intro wizard-panel--blue">
    <div class="wizard-panel__content wizard-panel__content--no-title">
      <p>
        Shiny is an R package that makes it easy to build interactive web
        apps straight from R.
      </p>
      <p>
        Let's walk through how to publish one.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShinyAppIntro',
};
</script>

<style lang="scss" scoped>
.wizard-panel {
  &__shiny-intro {
    background-image: url('./background.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
}
</style>
